import React from 'react';

const Field = ({type="tet",value,changeValue,placeholder}) => {
    return (
        <label className='label'>
           <input className='fr cw' placeholder={placeholder} type={type} onChange={(e)=>changeValue(e.currentTarget)} value={value}/> 
        </label>
    );
};

export default Field;